export const vimeoVideoRegEx = /^http(?:s?):\/\/(?:www\.)?vimeo\.com\/(\d+)$/i;

export const isValidVimeoUrl = (url: string = '') => {
  return vimeoVideoRegEx.test(url);
};
